<template>
<div>
    <b-container class="px-0">

        <b-row class="justify-content-md-center">
            <b-col cols=12>
                <b-card no-body tag="h1" class="border-0 pt-3 pb-3 bg-transparent">{{pageTitle}}
                </b-card>
            </b-col>
        </b-row>

        <b-row class="justify-content-md-center">
            <b-col cols="12" md="6" xl="4" class="mb-4" v-for="s in sub" :key="s['o:id']">
                <b-card  class="shadow p-0 mb-4 rounded bg-transparent" :img-src="s['foaf:depiction'] | imgUrl">
                    <b-card-title title-tag="h3" v-html="s['dcterms:title']['0']['@value']"> </b-card-title>
                    <div class="d-flex justify-content-center">
                        <b-button squared variant="primary" class="px-4 my-2 btn-index-card">
                            <router-link :to="{ path: '/digital/'+ s['o:id'] }">Vezi colecția</router-link>
                        </b-button>
                    </div>
                </b-card>
            </b-col>
        </b-row>

    </b-container>
</div>
</template>

<script>
export default {

    data() {
        return {
            pageTitle: 'Biblioteca Digitală',
            colectii: '',
            sub: []
        }
    },
    filters: {
        imgUrl: function (value) {
            if (value)            
            return value[0]['@id'];
            else 
            return require('../assets/imgplacehold.png')
        }
    },
    methods: {
        getColectii() {
            fetch('https://app.bibliotecaarad.ro/backend/api/iasubbiblioteca/' + this.$route.params.id)
                .then(response => response.json())
                .then(data => {
                    this.colectii = data;
                    this.getSubColectii();
                });
        },
        getSubColectii() {
            const data = this.colectii;
            const arr = data['0'].id_site.split(',');
            for (let index = 0; index < arr.length; index++) {
                const element = arr[index];
                fetch('https://digital.bibliotecaarad.ro/api/item_sets/' + element)
                    .then(response => response.json())
                    .then(data => this.sub.push(data));
            }
        },

    },
    created() {
        this.getColectii()
    }
}
</script>
